import { RunFacetField } from '@/types/schema';

import { DatasetSessionMetricColumn } from '../constants';

export function formatFacets(
  runFacets: RunFacetField[],
  metrics: DatasetSessionMetricColumn[]
): RunFacetField[] {
  return runFacets.map((facet) => {
    const matchingMetric = metrics.find(
      (metric) => facet.key === (metric.attribute || metric.name)
    );

    if (!matchingMetric) return facet;

    return {
      ...facet,
      key: matchingMetric.name,
      value: matchingMetric.attributeValueNames?.[facet.value] || facet.value,
    };
  });
}
